/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {ContextMenuModel} from './context.menu.model';
import {ContextMenuItemModel} from './context-menu-item.model';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';
import {CloseContextMenuService} from './services/close-context-menu.service';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'app-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContextMenuComponent {

    @Input() contextMenuModel: ContextMenuModel;
    private readonly DROPDOWN_ID = uuid().replace(/-/g, '');

    constructor(private closeMenusService: CloseContextMenuService) {}

    get contextMenuDataCy(): string {
        return this.contextMenuModel != null && this.contextMenuModel.code != null
                ? `context-menu-${this.contextMenuModel.code}`
                : 'context-menu-container';
    }

    get contextMenuToggleDataCy(): string {
        return this.contextMenuModel != null && this.contextMenuModel.code != null
                ? `context-menu-toggle-${this.contextMenuModel.code}`
                : 'context-menu-toggle';
    }

    hasVisualSeparator(item: ContextMenuItemModel): boolean {
        return item != null && item.hasTopSeparator != null && item.hasTopSeparator;
    }

    clickOnDropdownToggle(dropdown: NgbDropdown): void {
        if (dropdown.isOpen()) {
            this.closeMenusService.open(this.DROPDOWN_ID, dropdown);
        } else {
            this.closeMenusService.close(this.DROPDOWN_ID, dropdown);
        }
    }
}
